import unorm from 'unorm';

const normalize = value => {
  return value
    ? unorm
        .nfd(value)
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/(\s|\/|\||\\|\*|\<|\>|\&|\?|\+|\=)/g, '_')
        .toLowerCase()
    : '';
};

export default normalize;
